// 타이어 위치별 옵션 ID 매핑
export const TIRE_POSITION_MAP = [
	{ key: 'FL', label: '앞왼쪽', dataIndex: 0, manufacturerId: 81, treadMmId: 327, productionId: 82 },
	{ key: 'RL', label: '뒤왼쪽', dataIndex: 1, manufacturerId: 88, treadMmId: 328, productionId: 89 },
	{ key: 'FR', label: '앞오른쪽', dataIndex: 2, manufacturerId: 102, treadMmId: 330, productionId: 103 },
	{ key: 'RR', label: '뒤오른쪽', dataIndex: 3, manufacturerId: 95, treadMmId: 329, productionId: 96 },
];

export const CONNECTOR_KEYS = ['FL', 'FR', 'RL', 'RR'];

// 안전 한계점 (mm) — 주행가능거리 산출용
export const SAFETY_LIMIT_MM = 3;

// 1mm당 주행 가능 거리 (km)
export const KM_PER_MM = 10000;

// 교체 권장 기준 (mm) — 주행가능거리 산출용. 법적 한계선 1.6mm 이하면 '교체권장'
export const REPLACEMENT_THRESHOLD_MM = 1.6;

// 트레드 상태(카드 색상) 기준 (mm): 1.7mm 미만 경고, 이상 초록. 차량상세 선검수 요약과 동일 기준
export const TREAD_STATUS_LIMIT_MM = 1.7;

// 생산시기 원본 데이터 최소 길이 (WWYY)
export const PRODUCTION_DATE_MIN_LENGTH = 4;

// 상태 아이콘 색상 (정상=초록 / 경고=회색)
export const NORMAL_ICON_COLOR = '#00be91';
export const WARNING_ICON_COLOR = '#cccccc';
export const HELP_ICON_COLOR = '#dadada';

// 주행가능거리 표시 텍스트
export const DRIVABLE_DISTANCE_LOW_TEXT = '약 5,000km';
export const DRIVABLE_DISTANCE_REPLACE_TEXT = '교체권장';
